
import { mapActions, mapGetters } from 'vuex'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import store from './vuex/store'

export default {
store,
components: {
Loading,
Toast,
},
computed: {
...mapGetters({
isLoading: 'getLoading',
toastConfig: 'getToastOptions',
}),
},
methods: {
...mapActions(['showToast']),
isCurrent(name) {
return this.$route.name === name
},
onHideToast() {
this.showToast({ show: false })
},
},
}



// WEBPACK FOOTER //
// ./client/App.vue